export default function getBlockDepth(node) {
  return parseInt(node.getIn(['data', 'depth']) || 0);
}